export default __webpack_public_path__ + "static/media/appbar.f1f3f56f.svg";